import React from 'react';
/* --- import Components ----*/
import { BlogPostTitle, SentenceSmall } from '../Typography';
import { StaticImage } from 'gatsby-plugin-image';
/* --- import Styles and Images ----*/
import colors from 'src/style/colors';
import { mediaQueries } from 'src/style/breakpoints';
import Star from '../Icons/Star';

const SocialProof = ({ data }) => {
  return (
    <div
      css={{
        [mediaQueries.phoneOnly]: {
          width: '100%',
        },
      }}
    >
      <section
        css={{
          display: 'flex',
          gap: 50,
          margin: '25px 0px 35px 0px',
          [mediaQueries.phoneOnly]: {
            display: 'flex',
            justifyContent: 'center',
          },
        }}
      >
        <div>
          <BlogPostTitle>{data[0].number}</BlogPostTitle>
          <SentenceSmall>{data[0].text}</SentenceSmall>
        </div>
        <div
          css={{
            borderLeft: `${colors.white} 1px solid`,
            paddingLeft: 20,
          }}
        >
          <BlogPostTitle>{data[1].number}</BlogPostTitle>
          <SentenceSmall>{data[1].text}</SentenceSmall>
        </div>
      </section>
      {/* {data.length === 4 && (
        <section
          css={{
            display: 'flex',
            gap: 50,
            marginTop: 40,
            marginBottom: 40,
            [mediaQueries.phoneOnly]: {
              display: 'flex',
              justifyContent: 'center',
            },
          }}
        >
          <div>
            <BlogPostTitle>{data[2].number}</BlogPostTitle>
            <SentenceSmall>{data[2].text}</SentenceSmall>
          </div>
          <div
            css={{
              borderLeft: `${colors.white} 1px solid`,
              paddingLeft: 20,
            }}
          >
            <BlogPostTitle>{data[3].number}</BlogPostTitle>
            <SentenceSmall>{data[3].text}</SentenceSmall>
          </div>
        </section>
      )} */}
      <section
        css={{
          height: 100,
          marginTop: '25px',
          marginBottom: '50px',
          display: 'flex',
          gap: 30,
          alignItems: 'center',
          [mediaQueries.phoneOnly]: {
            justifyContent: 'center',
          },
          [mediaQueries.desktopUp]: {
            marginBottom: '0px',
          },
        }}
      >
        <div css={{ height: '100%' }}>
          <StaticImage
            src="../../data/images/awards/googlereview.png"
            alt="logo Google"
            // placeholder="none"
            css={{ height: '85%', aspectRatio: '1/1' }}
          />
          <div
            css={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Star width="15" height="15" />
            <Star width="15" height="15" />
            <Star width="15" height="15" />
            <Star width="15" height="15" />
            <Star width="15" height="15" />
          </div>
        </div>
        <div css={{ height: '100%' }}>
          <StaticImage
            src="../../data/images/awards/coursereport.png"
            alt="logo course report"
            // placeholder="none"
            css={{ height: '85%', aspectRatio: '1/1' }}
          />
          <div
            css={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Star width="15" height="15" />
            <Star width="15" height="15" />
            <Star width="15" height="15" />
            <Star width="15" height="15" />
            <Star width="15" height="15" />
          </div>
        </div>
        <div css={{ height: '100%' }}>
          <StaticImage
            src="../../data/images/awards/switchup.png"
            alt="logo switchup"
            // placeholder="none"
            css={{ height: '85%', aspectRatio: '1/1' }}
          />
          <div
            css={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Star width="15" height="15" />
            <Star width="15" height="15" />
            <Star width="15" height="15" />
            <Star width="15" height="15" />
            <Star width="15" height="15" />
          </div>
        </div>
      </section>
      {/* <section
        css={{
          display: 'flex',
          flexDirection: 'column',
          [mediaQueries.phoneOnly]: {
            alignItems: 'center',
          },
        }}
      >
        <Paragraph css={{ color: colors.yellow, paddingTop: 0, paddingBottom: 5 }}>
          Formation certifiante
        </Paragraph>
        <StaticImage
          src="../../data/images/institutionals/LogoQualiopi_rounded.png"
          alt="logo Qualiopi"
          css={{
            height: 110,
            width: 154,
            marginBottom: 40,
          }}
        />
      </section> */}
    </div>
  );
};

export default SocialProof;
